import { createContext } from 'react';
import { PortersContextType } from './types';

export const PortersContext = createContext<PortersContextType | null>(null);
